import { Fragment, useEffect } from 'react';
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../footer/Footer";
import Header from "../../header/Header";
import './MainLayout.scss';
const MainLayout = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const handleClickScroll = () => {
        const element = document.getElementById("root");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      };
    return (
        <Fragment>
            <Header logoClick={handleClickScroll}/>
            <main className="main_layout">
                <Outlet />
            </main>
            <Footer />
        </Fragment>
    )
}
export default MainLayout